import type { NonWorkingHoursV3CalendarEvent } from '../../../types';
import { stripeBackgroundStyle } from '../../styles';

interface Props {
  event: NonWorkingHoursV3CalendarEvent;
}
export const NonWorkingHoursV3 = ({ event }: Props) => {
  return <div data-event-type={event.eventType} css={stripeBackgroundStyle} />;
};
